"use strict";
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TableDomTraverser = (function () {
    function TableDomTraverser(validator) {
        if (validator === void 0) { validator = function () { return true; }; }
        this.validator = validator;
    }
    TableDomTraverser.prototype.cellBelow = function (el) {
        var rows = el.closest("tbody").rows || el.closest("table").rows;
        var table = toUnitTable(Array.from(rows));
        var cellAddress = findCellAddress(el, table);
        var address = this.cellAddressBelow(table, cellAddress);
        return address ? address.td : null;
    };
    TableDomTraverser.prototype.cellAbove = function (el) {
        var rows = el.closest("tbody").rows || el.closest("table").rows;
        var table = toUnitTable(Array.from(rows));
        var cellAddress = findCellAddress(el, table);
        var address = this.cellAddressAbove(table, cellAddress);
        return address ? address.td : null;
    };
    TableDomTraverser.prototype.cellLeft = function (el) {
        var rows = el.closest("tbody").rows || el.closest("table").rows;
        var table = toUnitTable(Array.from(rows));
        var cellAddress = findCellAddress(el, table);
        var address = this.cellAddressLeft(table, cellAddress);
        return address ? address.td : null;
    };
    TableDomTraverser.prototype.cellRight = function (el) {
        var rows = el.closest("tbody").rows || el.closest("table").rows;
        var table = toUnitTable(Array.from(rows));
        var cellAddress = findCellAddress(el, table);
        var address = this.cellAddressRight(table, cellAddress);
        return address ? address.td : null;
    };
    TableDomTraverser.prototype.cellAddressBelow = function (table, cellAddress) {
        var i = cellAddress.i, j = cellAddress.j, el = cellAddress.td;
        i += el.rowSpan;
        while (i < table.length) {
            var nextRow = table[i];
            var td = nextRow[j];
            if (this.validator(td)) {
                return { td: td, i: i, j: j };
            }
            i += td.rowSpan;
        }
        return null;
    };
    TableDomTraverser.prototype.cellAddressAbove = function (table, cellAddress) {
        var i = cellAddress.i, j = cellAddress.j;
        i--;
        while (i >= 0) {
            var prevRow = table[i];
            var td = prevRow[j];
            if (this.validator(td)) {
                return { td: td, i: i, j: j };
            }
            i--;
        }
        return null;
    };
    TableDomTraverser.prototype.cellAddressLeft = function (table, cellAddress) {
        var i = cellAddress.i, j = cellAddress.j;
        var cells = table[i];
        j--;
        while (j >= 0) {
            var td = cells[j];
            if (this.validator(td)) {
                return { td: td, i: i, j: j };
            }
            j--;
        }
        return null;
    };
    TableDomTraverser.prototype.cellAddressRight = function (table, cellAddress) {
        var i = cellAddress.i, j = cellAddress.j, el = cellAddress.td;
        var cells = table[i];
        j += el.colSpan;
        while (j < cells.length) {
            var td = cells[j];
            if (this.validator(td)) {
                return { td: td, i: i, j: j };
            }
            j += td.colSpan;
        }
        return null;
    };
    return TableDomTraverser;
}());
exports.TableDomTraverser = TableDomTraverser;
function toUnitTable(rows) {
    var e_1, _a, e_2, _b;
    var res = [];
    var cellBuffer = [];
    var j = 0;
    try {
        for (var _c = __values(Array.from(rows)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var row = _d.value;
            var i = 0;
            try {
                for (var _e = (e_2 = void 0, __values(Array.from(row.cells))), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var cell = _f.value;
                    while (i < cellBuffer.length && cellBuffer[i] !== undefined && cellBuffer[i].expires >= j) {
                        i++;
                    }
                    for (var k = 0; k < cell.colSpan; k++) {
                        cellBuffer[i + k] = { expires: j + cell.rowSpan - 1, cell: cell };
                    }
                    i += cellBuffer[i].cell.colSpan;
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_2) throw e_2.error; }
            }
            res.push(cellBuffer.map(function (p) { return p.cell; }));
            j++;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return res;
}
exports.toUnitTable = toUnitTable;
function findCellAddress(cell, table) {
    var row = cell.closest("tr");
    var rowIndex = getBodyRowIndex(row);
    var cells = table[rowIndex];
    var cellIndex = cells.findIndex(function (p) { return p === cell; });
    return {
        td: cell,
        i: rowIndex,
        j: cellIndex
    };
}
exports.findCellAddress = findCellAddress;
function getBodyRowIndex(row) {
    var skip = 0;
    var thead = row.closest("table").tHead;
    if (thead) {
        skip += thead.rows.length;
    }
    return row.rowIndex - skip;
}
